import z from 'zod';

export const articleTypesLiteral = z.enum(['article', 'theaterTalk']);
